import { render, staticRenderFns } from "./InstallChannel.vue?vue&type=template&id=dda65982&scoped=true"
import script from "./InstallChannel.vue?vue&type=script&lang=js"
export * from "./InstallChannel.vue?vue&type=script&lang=js"
import style0 from "./InstallChannel.vue?vue&type=style&index=0&id=dda65982&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda65982",
  null
  
)

export default component.exports